import { Menu, Image } from 'antd'
import { AppstoreOutlined, UserOutlined, CustomerServiceOutlined, BankOutlined  } from '@ant-design/icons'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function AdminSideMenu() {
  const navigate = useNavigate();
  return (
    <div className='adminSideMenu'>
      <Image
        width={150}
        src='/logoVer2.png'>
      </Image>
      <Menu
      onClick = {(item) =>{
        navigate(item.key)
      }}
      items = {
        [
          {
            label: "Tổng quan",
            icon: <AppstoreOutlined />,
            key: "/admin/overview",
          },
          {
            label: "Quản lý người dùng",
            icon: <UserOutlined />,
            key: "/admin/userList",
          },
          {
            label: "Quản lý nội dung",
            icon: <CustomerServiceOutlined />,
            key: "/admin/contentList",
          },
          {
            label: "Quản lý giao dịch",
            icon: <BankOutlined />,
            key: "/admin/monetization",
          }
        ]
      }
      selectedKeys={[window.location.pathname]}
      >
      </Menu>
    </div>
  )
}

export default AdminSideMenu